import { ScanCheckDecisionType } from '@src/constants/ScanCheckDecisionType';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
  option: ScanCheckDecisionType;
  consultantId?: string;
  procedureId?: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/scan/checked',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveScanCheck = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveScanCheckLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveScanCheck;
